import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const TicketAdvancedLayout = styled(Paper)(({ theme, hasTicket }) => ({
    height: `calc(100% - 48px)`,
    display: "grid",
    gridTemplateRows: "44px 1fr",
    overflow: "hidden",
    "@media (max-width: 960px)": {
        height: hasTicket ? "100vh" : "calc(100vh - 98px)",
        height: hasTicket ? "100dvh" : "calc(100dvh - 98px)",
        height: hasTicket ? "-webkit-fill-available" : "calc(100dvh - 98px)",
        gridTemplateRows: "1fr",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        maxHeight: hasTicket ? "100dvh" : undefined,
    },
}))

export default TicketAdvancedLayout;
